export enum Cookie {
    LOCALE = 'NEXT_LOCALE',
    NEXT_URL = 'NEXT_URL',
    AUTH_TOKEN = 'authToken',
    REFRESH_TOKEN = 'refreshToken',
    CHECKOUT_DATA = 'checkoutData',
    EXTERNAL_PAYMENT_STATUS = 'externalPaymentStatus',
    PAGES_VISITED = 'PAGES_VISITED',
    USER_PREFERENCES = 'USER_PREFERENCES',
    DASHBOARD = 'dashboard',
}
